import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const ApplianceRepair = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my appliance repair business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps appliance repair businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for appliance repair businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most appliance repair businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my appliance repair business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like appliance repair. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Appliance Repair - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Appliance Repair CRM", url: "/industries/appliance-repair" }
  ];

  const industryData = {
    name: 'Appliance Repair',
    title: 'Capture Emergency Repair Calls & Build Preventive Maintenance Contracts',
    subtitle: 'Never miss an urgent appliance breakdown call, automate scheduling, and convert repairs into maintenance plans',
    icon: '🛠️',
    challenges: [
      'Missing emergency calls = lost to competitors',
      'Hard to schedule multiple jobs efficiently',
      'Clients never call back for maintenance',
      'Difficult to manage parts inventory',
      'Time wasted giving estimates over phone'
    ],
    solutions: [
      'Emergency call routing captures every breakdown',
      'Smart scheduling based on location and parts',
      'Automated maintenance plan follow-ups',
      'Parts tracking and ordering automation',
      'Instant online estimates based on appliance type'
    ],
    features: [
      'Emergency call capture 24/7',
      'GPS-optimized scheduling',
      'Appliance history tracking',
      'Maintenance plan automation',
      'Parts inventory management',
      'Online estimate calculator',
      'Review automation',
      'Warranty tracking'
    ],
    results: [
      'Never miss an emergency call',
      '40% convert to maintenance plans',
      'Schedule 30% more jobs per day',
      '5.1K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Appliance Repair UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for appliance repair businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for appliance repair UK, appliance repair business software, appliance repair customer management, appliance repair lead generation UK"
        url="/industries/appliance-repair"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default ApplianceRepair;